export const ADMIN_BASE_URL = 'https://api.aurorabirth.com'
